import axios from 'lib/axios'

export const getFormInstanceApi = async ({ id, width }) => {
  return await axios.get(`/forms/v3/instance/${id}/data?width=${width}`)
}
